
import { catchError } from "rxjs/operators";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../../../environments/environment";
import { HandleError, HttpErrorHandler } from "../../../../../util/http-error-handler.service";
import { Observable } from "rxjs";
import HorarioFuncionamento from "../../../../../models/perfil/horario-funcionamento.model";
import { Perfil } from "../../../../../models/perfil/perfil.model";


const API_URL = environment.apiUrl;

@Injectable({
  providedIn: "root"
})
export class LojaService {
  private handleError: HandleError;

  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {
    this.handleError = httpErrorHandler.createHandleError("notificacaoService");
  }




  detalhar(): Observable<Perfil> {
    return this.http
      .get<any>(`${API_URL}v1/perfil/detail`)
      .pipe(catchError(this.handleError("detalhar", [])));
  }

}
